export default __webpack_public_path__ + "static/media/ADA.da2cdd7d.svg";